import {
  required,
  confirmed,
  length,
  email,
  regex,
  min,
  max,
} from 'vee-validate/dist/rules'
import { extend, localize, setInteractionMode } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'

setInteractionMode('eager')

extend('required', { ...required })
extend('regex', { ...regex })
extend('min', { ...min })
extend('max', { ...max })
extend('email', { ...email, message: '有効なメールアドレスではありません' })
extend('confirmed', { ...confirmed })
extend('length', { ...length })

// @link https://qiita.com/mpyw/items/886218e7b418dfed254b
// eslint-disable-next-line
const passwordRegExp =
  /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!-\/:-@[-`{-~])[!-~]{10,100}$/
extend('password', {
  validate: (value) => passwordRegExp.test(value),
  message:
    'パスワードは英大文字、英小文字、数字、記号全て含む10文字以上で入力してください',
})

extend('mobile', {
  validate: (value) => {
    return /^(050|060|070|080|090)([0-9]{8})$/.test(value)
  },
  message: '携帯電話番号は半角数字11桁で入力してください',
})

extend('tel', {
  validate: (value) => {
    if (/^(050|060|070|080|090)/.test(value)) {
      return /^[0-9]{11}$/.test(value)
    }
    return /^[0-9]{10}$/.test(value)
  },
  message: '電話番号は半角数字10~11桁で入力してください',
})

extend('not_same_as_tel', {
  params: ['target'],
  validate(value = '', { target = '' }: any) {
    // ハイフンを抜いてチェックする
    return value.replace(/-/g, '') !== target.replace(/-/g, '')
  },
  message: 'ご本人以外の連絡先をご登録ください。',
})

extend('katakana', {
  validate: (value) => {
    return /^([ァ-ヴ][ァ-ヴー・]*)$/.test(value)
  },
  message: '全角カタカナで入力してください',
})

localize('ja', ja)
